import {AvatarMenu, AvatarMenuItem} from '@coolcolduk/ui-mui';
import {AppBar, Container, Toolbar} from '@mui/material';
import {User} from '@cp/model';
import NavBarDesktopMenu from './NavBarDesktopMenu';
import NavBarLogo from './NavBarLogo';

interface NavBarDesktopProps {
  user: User;
  navItems: AvatarMenuItem[];
  userMenu: AvatarMenuItem[];
}

export default function NavBarDesktop({user, navItems, userMenu}: NavBarDesktopProps) {
  // Use userRecord if available, fallback to Firebase user data
  const displayName = user?.name || user?.email?.split('@')[0] || 'User';
  const photoUrl = user?.photoUrl;

  return (
    <AppBar data-testid="navbar-desktop" position="sticky" elevation={0} sx={{backgroundColor: 'background.paper'}}>
      <Container maxWidth="lg">
        <Toolbar sx={{px: {xs: 0}}}>
          <NavBarLogo />

          <NavBarDesktopMenu navItems={navItems} />

          {/* User Avatar */}
          <AvatarMenu
            items={userMenu}
            avatarSrc={photoUrl}
            avatarAlt={displayName}
            label={displayName}
            showLabel={false}
            data-testid="navbar-desktop-user-menu-button"
          />
        </Toolbar>
      </Container>
    </AppBar>
  );
}
